import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const deleteWishlistItemTagProps = z
  .object({
    token: z.string(),
    tag: z.number(),
    itemId: z.number(),
  })
  .extend(requestConfig.shape);

export type DeleteWishlistItemTagProps = z.infer<
  typeof deleteWishlistItemTagProps
>;

export const deleteWishlistItemTag = async (
  args: DeleteWishlistItemTagProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    tag,
    token,
    itemId,
    proxyAuthSecret,
  } = parseServiceInput(deleteWishlistItemTagProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist/${tag}/${itemId}`, {
    method: "DELETE",
    headers,
  });

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
